import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';


const About = () => {
  return (
    <div>

      <div className='mt-10 text-center px-3' data-aos="fade-up" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="350">
        <h1 className='text-xl font-bold underline text-main'>
          About
        </h1>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' >
          Devorah is an expert aesthetician and the founder of Devorah's Lane, the address for hair removal and skincare.

        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' >
          With a lifelong commitment to helping women achieve flawless, radiant skin, she prides herself on skillfully correcting blemishes and enhancing skin texture.        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' >
          Step into her advanced medispa, nestled amidst a picturesque garden, and experience the latest in hair removal and skin treatments.        </p>



        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-bold px-2 text-main' >
          Devorah's international training and genuine care for people ensure a sanctuary to unwind and indulge in well-deserved pampering.        </p>
      </div>

    </div>

  )

}


export default About